import { create } from 'zustand';

import { observeStreamStatus } from '@/queries/utils/status-observations';

// Both HTTP visibility and confirmed deletions are scoped to the receiving account.
const useStatusAvailabilityStore = create<{
  unavailable: Record<string, Record<string, true>>;
  deleted: Record<string, Record<string, true>>;
}>(() => ({ unavailable: {}, deleted: {} }));

const setStatusUnavailable = (scope: string, id: string, unavailable: boolean) => {
  useStatusAvailabilityStore.setState((state) => {
    if (!unavailable && state.deleted[scope]?.[id]) return state;
    if (!!state.unavailable[scope]?.[id] === unavailable) return state;
    const statuses = { ...state.unavailable[scope] };
    if (unavailable) statuses[id] = true;
    else delete statuses[id];
    const scopes = { ...state.unavailable };
    if (Object.keys(statuses).length) scopes[scope] = statuses;
    else delete scopes[scope];
    return { unavailable: scopes };
  });
};

const isStatusDeleted = (scope: string, id: string) =>
  !!useStatusAvailabilityStore.getState().deleted[scope]?.[id];

const markStatusDeleted = (scope: string, id: string) => {
  useStatusAvailabilityStore.setState((state) => ({
    deleted: { ...state.deleted, [scope]: { ...state.deleted[scope], [id]: true } },
    unavailable: { ...state.unavailable, [scope]: { ...state.unavailable[scope], [id]: true } },
  }));
  // Supersede in-flight reads without removing cached entities or reply edges.
  observeStreamStatus(scope, id);
};

export { useStatusAvailabilityStore, setStatusUnavailable, isStatusDeleted, markStatusDeleted };
